import { render, staticRenderFns } from "./TabTemplates.vue?vue&type=template&id=9e93bb16&scoped=true"
import script from "./TabTemplates.vue?vue&type=script&lang=js"
export * from "./TabTemplates.vue?vue&type=script&lang=js"
import style0 from "./TabTemplates.vue?vue&type=style&index=0&id=9e93bb16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93bb16",
  null
  
)

export default component.exports